import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import dataFlow from "../../img/SDL-dataflow.png";
import carmina from "../../img/carmina.jpg";
import ryan from "../../img/ryan.jpg";
import jaswanth from "../../img/jaswanth.jpg";
import sam from "../../img/sam.jpg"

import { 
  Box, 
  Typography,
  useTheme,
} from '@mui/material';



const HomeComponent = (props) => {
  const [, setIsReducedLayout] = useState(false);
  const location = useLocation();
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  const isXSmall = useMediaQuery({ query: "(max-width: 600px)" });

  useEffect(() => {
    setIsReducedLayout(isXSmall);
  }, [location.state, isXSmall]);
  const itemData = [
    {
      img: jaswanth,
      title: "Jaswanth Aavula",
      author: "Manager",
      link: "https://peoplefinder.gm.com/Person/Show/KZZJXL/",
    },
    {
      img: carmina,
      title: "Carmina Echipare",
      author: "Software Engineer",
      link: "https://peoplefinder.gm.com/Person/Show/QZN70T/",
    },
    {
      img: ryan,
      title: "Ryan Abukarn",
      author: "Software Engineer",
      link: "https://peoplefinder.gm.com/Person/Show/SZPYGL/",
    },
    {
      img: sam,
      title: "Sam Sidelinger",
      author: "Software Engineer",
      link: "https://peoplefinder.gm.com/Person/Show/JZHNHZ/",
    },
  ];


  return (
    <Box sx={{ 
      maxWidth: 1400, 
      mx: 'auto', 
      px: { xs: 2, md: 4 }, 
      py: 3,
      height: 'calc(100vh - 80px)',
      display: 'flex',
      flexDirection: 'column',
    }}>
      {/* --- Title Section --- */}
      <Box sx={{ mb: 3, textAlign: 'center' }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 600,
            mb: 1.5,
          }}
        >
          Software Defined Logger (SDL)
        </Typography>

        <Typography
          variant="body1"
          sx={{
            textAlign: 'center',
            color: 'text.secondary',
            maxWidth: 900,
            mx: 'auto',
            lineHeight: 1.6,
            fontSize: '1rem',
          }}
        >
          Provides a flexible and efficient platform for managing, processing, and visualizing log data. The system is built with modular components allowing scalable data ingestion and intuitive analysis workflows.
        </Typography>
      </Box>

      {/* --- Picture and Team Side by Side --- */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          gap: 4,
          alignItems: 'center',
          flex: 1,
          overflow: 'hidden',
        }}
      >
        {/* Data Flow diagram - Left Side */}
        <Box
          sx={{
            flex: 1.2,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: 0,
            height: '100%',
          }}
        >
          <Box
            sx={{
              borderRadius: 3,
              overflow: 'hidden',
              backgroundColor: isDark ? 'rgba(255,255,255,0.95)' : 'transparent',
              p: isDark ? 2 : 0,
              maxHeight: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Box
              component="img"
              src={dataFlow}
              alt="Data Flow Architecture"
              sx={{
                width: '100%',
                height: 'auto',
                objectFit: 'contain',
                maxHeight: '100%',
              }}
            />
          </Box>
        </Box>

        {/* --- Meet the Team Section - Right Side --- */}
        <Box sx={{ 
          flex: 0.8, 
          textAlign: 'center', 
          display: 'flex', 
          flexDirection: 'column',
          justifyContent: 'center',
          bgcolor: isDark ? 'background.paper' : 'transparent',
          borderRadius: isDark ? 3 : 0,
          p: isDark ? 3 : 0,
          border: isDark ? '1px solid' : 'none',
          borderColor: 'divider',
        }}>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 600,
              mb: 3,
            }}
          >
            Meet Our Team
          </Typography>
          {/* Team Members */}
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: 'repeat(2, 1fr)', sm: 'repeat(2, 1fr)' },
              gap: 3,
              justifyContent: 'center',
            }}
          >
            {itemData.map((item) => (
              <Box
                key={item.title}
                component="a"
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textDecoration: 'none',
                  color: 'inherit',
                  transition: 'transform 0.2s',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                  },
                }}
              >
                <Box
                  sx={{
                    width: 100,
                    height: 100,
                    borderRadius: '50%',
                    overflow: 'hidden',
                    border: '2px solid',
                    borderColor: 'divider',
                    mb: 1.5,
                    transition: 'all 0.2s',
                    '&:hover': {
                      borderColor: 'primary.main',
                      boxShadow: isDark
                        ? '0 4px 12px rgba(0,0,0,0.4)'
                        : '0 4px 12px rgba(0,0,0,0.1)',
                    },
                  }}
                >
                  <img
                    src={`${item.img}?w=200&auto=format`}
                    alt={item.title}
                    loading="lazy"
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  />
                </Box>

                <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5, fontSize: '0.95rem' }}>
                  {item.title}
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '0.85rem' }}>
                  {item.author}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default HomeComponent;
